import React from 'react'
import {connect} from 'dva'
import {framework_tool, component_tool, utils_tool} from '@/tool'
import {modelUtils} from '@/utils'

const {WizForm, WizRow, WizCol, WizInput, WizButton} = component_tool
const {WizContainer} = framework_tool
const {isType} = utils_tool
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'

const organizationConfig = WizTableForm.Config.organizationBrandNode(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: [2]
  }
})
const positionCategoryConfig = WizTableForm.Config.positionCategory(this, {apiParams: {state: 1}})

class Editor extends WizContainer {
  componentName = 'Editor'

  constructor(props) {
    super(props)
    this.state = {
      timestamp: new Date().getTime()
    }
  }

  _ok = (data) => {
    this.doAction({
      path: 'syncEmailConfig/save',
      payload: {
        key: 'syncEmailConfig@save',
        apiParams: data
      }
    })
  }


  propsAndStateOnChange = {
    save: this._saveOnChange.bind(this)
  }

  _saveOnChange(nextProps, nextState) {
    if (nextProps.save.code === 1) {
      wizNotice.success('操作成功')
      this.props.changeModal(false, true);
      let {editorSuccess} = this.props
      editorSuccess && editorSuccess()
    } else {
      wizNotice.error(nextProps.save.msg)
    }
  }


  render() {
    let self = this;
    const {record: initialValue = {}} = this.props;
    const {emailList} = this.state

    const columns = [
      {
        name: 'id',
        dataIndex: 'id',
        formItem: {
          type: 'hidden',
          initialValue: initialValue['id']
        }
      },
      {
        title: "品牌",
        name: "orgIds",
        dataIndex: "orgIds",
        formItem: {
          ...organizationConfig,
          diy: WizTableForm,
          selectType: 'checkbox',
          initialValue: initialValue['orgList']?.map(item => item?.id) || [],
          initRows: initialValue['orgList'],
          rules: [
            {required: true, message: '请选择品牌'},
          ]
        },
      },
      {
        title: "岗位分类",
        name: "positionCategoryIds",
        dataIndex: "positionCategoryIds",
        formItem: {
          ...positionCategoryConfig,
          diy: WizTableForm,
          selectType: 'checkbox',
          initialValue: initialValue['positionCategoryList']?.map(item => item?.id) || [],
          initRows: initialValue['positionCategoryList'],
          rules: [
            {required: true, message: '请选择岗位分类'},
          ]
        },
      },
      {
        title: "邮箱",
        name: "emails",
        dataIndex: "emails",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator, getFieldValue, setFieldsValue} = form;
            let inputs = (emailList || initialValue['emailList'])?.map((item, i) => {
              return (
                <WizRow>
                  <WizCol span={20}>
                    {getFieldDecorator(`emails[${i}]`, {
                      initialValue: item,
                      rules: [
                        {required: true, message: '请输入邮箱'},
                      ]
                    })(<WizInput/>)}
                  </WizCol>
                  <WizCol span={4}>
                    <WizButton onClick={() => {
                      let tmp = emailList || JSON.parse(JSON.stringify(initialValue['emailList']));
                      tmp.splice(i, 1);
                      self.setState({emailList: tmp,xxx: new Date().getTime()})
                    }}>删除</WizButton>
                  </WizCol>
                </WizRow>
              )
            })

            return (
              <WizRow>
                <WizRow>
                  <WizCol span={24}>
                    {inputs}
                  </WizCol>
                </WizRow>
                <WizRow>
                  <WizCol span={24}>
                    <WizButton onClick={() => {
                      let tmp = emailList || JSON.parse(JSON.stringify(initialValue['emailList'] || []));
                      tmp.push(null);
                      self.setState({emailList: tmp, xxx: new Date().getTime()})
                    }}>新增</WizButton>
                  </WizCol>
                </WizRow>
              </WizRow>
            );
          },
        },
      },
    ]

    const formProps = {
      key: this.state.timestamp,
      ref: 'form',
      columns,
      record: null,
      preview: false,
      onSubmit: this._ok,
      formItemLayout: {
        labelCol: {span: 5},
        wrapperCol: {span: 16}
      }
    }

    return <WizForm {...formProps} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const {syncEmailConfig} = state
  const save = modelUtils.getModelEntity(syncEmailConfig, 'syncEmailConfig@save')
  return {
    save
  }
}

const options = {withRef: true}

export default connect(mapStateToProps, null, null, options)(Editor)
